import "stylesheets/application";

import Vue from "vue";
Vue.config.productionTip = false;

import "@app/plugins/bootstrap-vue";
import "@app/plugins/vueMoment";
import "@app/plugins/vue-highlightjs";
import "@app/plugins/vee-validate";
import "@app/plugins/vue-shortkey";
import "@app/plugins/portal-vue";
import { wait } from "@app/plugins/vue-wait";

import axios from "axios";

let token = document.getElementsByName("csrf-token")[0].getAttribute("content");
axios.defaults.headers.common["X-CSRF-Token"] = token;
axios.defaults.headers.common["Accept"] = "application/json";

import "@app/utils/directives";
import App from "@app/App";
import store from "@app/store";
import router from "@app/router";

import { sync } from "vuex-router-sync";
sync(store, router);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  wait,
  render: h => h(App)
}).$mount("#app");
